import { createSelector } from 'reselect';

const selectTermsLibraries = (state: any) => state.termsLibraries;


export const selectTermsLibrariesCurrentItem = createSelector([selectTermsLibraries], (termsLibraries) => termsLibraries.current);

export const selectTermsLibrariesListItems = createSelector([selectTermsLibraries], (termsLibraries) => termsLibraries.list);

export const selectTermsLibrariesItemById = (itemId: any) =>
    createSelector(selectTermsLibrariesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTermsLibrariesQueryItems = createSelector([selectTermsLibraries], (termsLibraries) => termsLibraries.query);

export const selectTermsLibrariesCreatedItem = createSelector([selectTermsLibraries], (termsLibraries) => termsLibraries.create);

export const selectTermsLibrariesUpdatedItem = createSelector([selectTermsLibraries], (termsLibraries) => termsLibraries.update);

export const selectTermsLibrariesReadItem = createSelector([selectTermsLibraries], (termsLibraries) => termsLibraries.read);

export const selectTermsLibrariesDeletedItem = createSelector([selectTermsLibraries], (termsLibraries) => termsLibraries.delete);

export const selectTermsLibrariesSearchedItems = createSelector([selectTermsLibraries], (termsLibraries) => termsLibraries.search);

export const selectTermsLibrariesItemsCount = createSelector([selectTermsLibraries], (termsLibraries) => termsLibraries.count);

export const selectTermsLibrariesItemsFilter = createSelector([selectTermsLibraries], (termsLibraries) => termsLibraries.filter);